import { render, staticRenderFns } from "./NewOQCqianhe.vue?vue&type=template&id=c07fdc7a&scoped=true"
import script from "./NewOQCqianhe.vue?vue&type=script&lang=js"
export * from "./NewOQCqianhe.vue?vue&type=script&lang=js"
import style0 from "./NewOQCqianhe.vue?vue&type=style&index=0&id=c07fdc7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07fdc7a",
  null
  
)

export default component.exports